// extracted by css-extract-rspack-plugin
export default {"section":"_b5062060","content":"_75844100"};